import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';

import {CardModule} from '../../../../../../../core/component/card/card.module';
import {ReactiveFormsModule} from '@angular/forms';
import {
    ReportComponentLabelDefaultValueLeftRightRowsJsonHandlerComponent
} from './report-component-label-default-value-left-right-rows-json-handler.component';
import {
    LabelSummaryFieldModule
} from '../../../../../../../core/component/label-summary-field/label-summary-field.module';
import {
    FormArrayInputModule
} from '../../../../../../../../components/common/form-array/form-array-input/form-array-input.module';
import {IonicModule} from '@ionic/angular';
import {FormFieldModule} from '../../../../../../../core/component/form-field/form-field.module';
import {InputTextModule} from '../../../../../../../core/component/input-text/input-text.module';
import {
    FormDefinitionFieldSearchByLabelModule
} from '../../../../api/component/form-definition-field-search-by-label/form-definition-field-search-by-label.module';
@NgModule({
    imports: [
        CommonModule,
        ReactiveFormsModule,
        FormArrayInputModule,
        IonicModule,
        FormFieldModule,
        InputTextModule,
        FormDefinitionFieldSearchByLabelModule,
    ],
    declarations: [
        ReportComponentLabelDefaultValueLeftRightRowsJsonHandlerComponent,
    ],
    exports: [
        ReportComponentLabelDefaultValueLeftRightRowsJsonHandlerComponent
    ],
})
export class ReportComponentLabelDefaultValueLeftRightRowsJsonHandlerModule {
}
